export default __webpack_public_path__ + "static/media/checkbox-avoid.ebbc1729.svg";